import { Lookup, useLookup } from '@/providers'
import { Autocomplete, TextField } from '@mui/material'
import { UrlUpdateType } from 'use-query-params'

type Props = {
	value: string | null
	updateFilters: (changes: any, updateTypeOverride?: UrlUpdateType) => void
}

export default function Exclusion({ value, updateFilters }: Props) {
	const options = useLookup(Lookup.ExclusionFilters)

	const selectedValues = options.find((v) => v.id === value) || null

	const handleChange = (e, value) => {
		if (value) {
			updateFilters({ exclusion: value.id })
		} else {
			updateFilters({ exclusion: '' })
		}
	}

	return (
		<Autocomplete
			fullWidth
			size="small"
			options={options}
			value={selectedValues}
			onChange={handleChange}
			renderInput={(params) => <TextField {...params} label="Exclusion" />}
			slotProps={{ paper: { style: { width: '24rem' } } }}
		/>
	)
}
